// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DropdownMenu_dropdown-menu-container__2QQwt {
  position: relative;
}
.DropdownMenu_dropdown-menu-container__header__ZS7EU {
  cursor: pointer;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: var(--m-text-muted);
  -webkit-user-select: none;
  user-select: none;
}
.DropdownMenu_dropdown-menu-container__header__ZS7EU:hover {
  background-color: #eceff1;
}
.DropdownMenu_dropdown-menu-container__header__ZS7EU span {
  font-size: var(--m-font-size-250);
  color: tomato;
}
.DropdownMenu_dropdown-menu-container__header__ZS7EU .DropdownMenu_icon__nY027 {
  font-size: 20px;
}
.DropdownMenu_dropdown-menu-container__content__YrrLL {
  min-width: 10rem;
  width: fit-content;
  height: fit-content;
  font-size: 0.9rem;
  border-radius: var(--m-border-radius);
  box-shadow: var(--m-dropdown-shadow);
  z-index: var(--m-z-index-dropdown);
  border: 1px solid var(--m-border-tooltip);
  position: fixed;
  padding: 0.2rem 0;
  background-color: var(--m-card-background-color);
  transition: opacity 0.3s ease-in-out;
  opacity: 0;
  visibility: hidden;
}
.DropdownMenu_dropdown-menu-container__content--visible__HhMsU {
  opacity: 1;
  visibility: visible;
}
.DropdownMenu_dropdown-menu-container__content__item__y\\+Ozb {
  width: 100%;
  padding: 0.5rem 1rem;
  clear: both;
  font-weight: 400;
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--m-text);
}
.DropdownMenu_dropdown-menu-container__content__item__y\\+Ozb:hover {
  background-color: var(--m-dropdown-hover);
}
.DropdownMenu_dropdown-menu-container__content__item--icon__KJ\\+IU {
  font-size: 22px;
  display: flex;
  align-items: center;
}

[m-data-theme=dark] .DropdownMenu_dropdown-menu-container__header__ZS7EU:hover {
  background-color: var(--m-subtle-card-background-color);
}`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/DropdownMenu/DropdownMenu.module.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AACI;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,0BAAA;EACA,yBAAA;EAGQ,iBAAA;AAChB;AACQ;EACI,yBAAA;AACZ;AAEQ;EACI,iCAAA;EACA,aAAA;AAAZ;AAGQ;EACI,eAAA;AADZ;AAKI;EACI,gBAAA;EAGA,kBAAA;EAGA,mBAAA;EACA,iBAAA;EAEA,qCAAA;EACA,oCAAA;EACA,kCAAA;EACA,yCAAA;EACA,eAAA;EACA,iBAAA;EACA,gDAAA;EAEA,oCAAA;EAEA,UAAA;EACA,kBAAA;AANR;AAQQ;EACG,UAAA;EACA,mBAAA;AANX;AASQ;EACI,WAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;AAPZ;AASY;EACI,yCAAA;AAPhB;AAUY;EACI,eAAA;EACA,aAAA;EACA,mBAAA;AARhB;;AAkBY;EACI,uDAAA;AAfhB","sourcesContent":[".dropdown-menu-container {\n    position: relative;\n\n    &__header {\n        cursor: pointer;\n        width: 30px;\n        height: 30px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 50%;\n        color: var(--m-text-muted);\n        -webkit-user-select: none;\n           -moz-user-select: none;\n            -ms-user-select: none;\n                user-select: none;\n\n        &:hover {\n            background-color: #eceff1;\n        }\n\n        span {\n            font-size: var(--m-font-size-250);\n            color: tomato\n        }\n\n        .icon {\n            font-size: 20px;\n        }\n    }\n\n    &__content {\n        min-width: 10rem;\n        width: -webkit-fit-content;\n        width: -moz-fit-content;\n        width: fit-content;\n        height: -webkit-fit-content;\n        height: -moz-fit-content;\n        height: fit-content;\n        font-size: 0.9rem;\n        // color: #212529;\n        border-radius: var(--m-border-radius);\n        box-shadow: var(--m-dropdown-shadow);\n        z-index: var(--m-z-index-dropdown);\n        border: 1px solid var(--m-border-tooltip);\n        position: fixed;\n        padding: 0.2rem 0;\n        background-color: var(--m-card-background-color);\n\n        transition: opacity .3s ease-in-out;\n       \n        opacity: 0;\n        visibility: hidden;\n\n        &--visible {\n           opacity: 1;\n           visibility: visible;\n        }\n\n        &__item {\n            width: 100%;\n            padding: 0.5rem 1rem;\n            clear: both;\n            font-weight: 400;\n            text-align: inherit;\n            text-decoration: none;\n            white-space: nowrap;\n            background-color: transparent;\n            border: 0;\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            color: var(--m-text);\n\n            &:hover {\n                background-color: var(--m-dropdown-hover);\n            }\n\n            &--icon {\n                font-size: 22px;\n                display: flex;\n                align-items: center;\n            }\n        }\n        \n    }\n}\n\n[m-data-theme=\"dark\"] {\n    .dropdown-menu-container {\n        &__header {\n            &:hover {\n                background-color: var(--m-subtle-card-background-color);\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown-menu-container": `DropdownMenu_dropdown-menu-container__2QQwt`,
	"dropdown-menu-container__header": `DropdownMenu_dropdown-menu-container__header__ZS7EU`,
	"icon": `DropdownMenu_icon__nY027`,
	"dropdown-menu-container__content": `DropdownMenu_dropdown-menu-container__content__YrrLL`,
	"dropdown-menu-container__content--visible": `DropdownMenu_dropdown-menu-container__content--visible__HhMsU`,
	"dropdown-menu-container__content__item": `DropdownMenu_dropdown-menu-container__content__item__y+Ozb`,
	"dropdown-menu-container__content__item--icon": `DropdownMenu_dropdown-menu-container__content__item--icon__KJ+IU`
};
export default ___CSS_LOADER_EXPORT___;
